/* eslint-disable @typescript-eslint/no-explicit-any */
import style from '../style/content.module.less';
import { Button } from 'antd';
import IconFont from '@/common/IconFont';
import { Input, Select, Drawer } from 'antd';
import { useEffect, useState, useRef } from 'react';
import TableCard from './TableCard';
import { useSelector, useDispatch } from '@/hooks/hooks';
import { loadTableAsync, resetParams, setParams, closeDrawer, changeFormMode } from '@/store/slices/page';
import { CloseOutlined } from '@ant-design/icons';
import React from 'react';

/**
 * @ 搜索区域
 */
const Search: React.FC<{
  items: SearchParams[];
  initFn: InitFn ;
}> = props => {
  const { searchWrapper, item } = style;
  const state = useSelector(i => i.page);
  const dispath = useDispatch();
  // const params: Record<string, string | undefined> = {};
  const search = () => {
    dispath(loadTableAsync({
      fn: props.initFn,
      params: {
        ...state.params,
        pageNum: 1,
        pageSize: state.pageSize
      }
    }));
  };
  useEffect(() => {
    search();
  }, []);
  const reset = async () => {
    dispath(resetParams({
      fn: props.initFn,
      params: {
        pageNum: 1,
        pageSize: state.pageSize
      }
    }));
  };
  return (
    <div className={searchWrapper}>
      {
        props.items.map(i => {
          switch (i.type) {
          case 'input':
            return <Input
              className={item}
              key={i.field}
              placeholder={i.placeholder}
              value={state.params[i.field]}
              onChange={e => {
                dispath(setParams({
                  fieldName: i.field,
                  value: e.target.value
                }));
              }}
              style={{
                width: (i.width || 160) + 'px'
              }}
              maxLength={i.maxLength || 30}
            />;
          case 'select':
            return <Select
              className={item}
              placeholder={i.placeholder}
              key={i.field}
              value={state.params[i.field]}
              onChange={e => {
                dispath(setParams({
                  fieldName: i.field,
                  value: e
                }));
              }}
            >
              {
                i.selectOptions?.map(j => <Select.Option key={j.value}>{j.label}</Select.Option>)
              }
            </Select>;
          default:
            return <></>;
          }
        })
      }
      <Button
        icon={<IconFont type="icon-zhongzhiqingkong" />}
        onClick={() => reset()}
      >
        重置
      </Button>
      <Button
        type="primary"
        icon={ <IconFont style={{ color: '#fff' } }type="icon-sousuo" />}
        onClick={() => search()}
      >
        搜索
      </Button>
    </div>
  );
};

const Content: React.FC<PageConfig> = props => {
  const [loading, setLoading] = useState(false);
  const state = useSelector(s => s.page);
  const dispatch = useDispatch();
  const ref = useRef();

  const close = () => {
    dispatch(closeDrawer());
  };
  const save = async () => {
    setLoading(true);
    try {
      const res = await (ref.current as any).save();
      res && (() => {
        close();
        dispatch(loadTableAsync({
          fn: props.initFn,
          params: {
            ...state.params,
            pageNum: state.pageNum,
            pageSize: state.pageSize
          }
        }));
      })();
    } finally {
      setLoading(false);
    }
  };
  const modeTitleMap = new Map([
    ['add', `新增${props.tableCardProps.drawerTitle}`],
    ['update', `修改${props.tableCardProps.drawerTitle}`],
    ['preview', '详情']
  ]);
  return (
    <div>
      <Search items={props.searchParams} initFn={props.initFn}></Search>
      <TableCard {...props.tableCardProps} initFn={props.initFn}></TableCard>
      <Drawer
        visible={state.showDrawer}
        width={550}
        // maskClosable={false}
        closable={false}
        onClose={() => close()}
        extra={<CloseOutlined onClick={close} style={{ cursor: 'pointer' }} />}
        title={modeTitleMap.get(state.drawerMode as string)}
      >
        <div className={`${style.drawerWrapper} drawerWrapper-${state.drawerMode}`}>
          <div className={style.drawerContent}>
            <props.form ref={ref} />
            {state.drawerMode === 'preview' &&
              <Button className={style.updateBtn} onClick={() => dispatch(changeFormMode('update'))} icon={<IconFont type="icon-xiugai1" />}>修改</Button>
            }
          </div>
          <div className={`${style.drawerBtn} drawerBtn-${state.drawerMode}`}>
            <Button onClick={close}>取消</Button>
            <Button loading={loading} type="primary" onClick={() => save()}>保存</Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export const initialState = {
  list: [] as unknown[],
  loading: false,
  pageNum: 1,
  pageSize: 10,
  total: 0,
  params: {} as Record<string, string | number | undefined>,
  showDrawer: false,
  drawerMode: 'add' as 'add' | 'update' | 'preview' | undefined,
  formFields: {} as unknown
};
export default Content;
